import {
  DASHBOARDS_REQUEST_FAIL,
  DASHBOARDS_REQUEST_SUCCESS
} from '../action.types'
import initialState from '../initial.state'

export default (state = initialState.dashboards, action) => {
  switch (action.type) {
    case DASHBOARDS_REQUEST_SUCCESS:
      return [...action.payload]
    case DASHBOARDS_REQUEST_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/dashboards.reducer.js